import { render, staticRenderFns } from "./IconGlobe.vue?vue&type=template&id=e52c1fd2&"
import script from "./IconGlobe.vue?vue&type=script&lang=js&"
export * from "./IconGlobe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e52c1fd2')) {
      api.createRecord('e52c1fd2', component.options)
    } else {
      api.reload('e52c1fd2', component.options)
    }
    module.hot.accept("./IconGlobe.vue?vue&type=template&id=e52c1fd2&", function () {
      api.rerender('e52c1fd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconGlobe.vue"
export default component.exports